import {observer} from 'mobx-react-lite';
import React from 'react';
import {classy} from 'webapp-lib/utils';

import {
  DisabledOverlay,
  StyledSubTabBar,
  SubTabButton,
} from './SubTabBar.styles';

export type SubTabItem<T extends object = object> = T & {
  id?: string | number;
  text: string;
  mode?: 'default' | 'important';
};

export type SubTabBarProps<T extends object> = {
  activeTabItem?: SubTabItem<T>;
  disabled?: boolean;
  items: SubTabItem<T>[];
  onChange: (arg0: SubTabItem<T>) => void;
  fullWidth?: boolean;
  testId?: string;
};

const USubTabBar = <T extends object = SubTabItem>({
  items,
  onChange,
  activeTabItem,
  disabled,
  fullWidth = false,
  testId,
}: SubTabBarProps<T>): React.ReactElement => (
  <StyledSubTabBar
    className={classy({SubTabBar: true, 'full-width': Boolean(fullWidth)})}
  >
    {disabled ? <DisabledOverlay data-testid='disabled-overlay' /> : null}
    {items.map((item, index) => (
      <SubTabButton
        key={item.id || index}
        active={activeTabItem?.id === item.id}
        className={classy({
          SubTabBarButton: true,
          important: item.mode === 'important',
        })}
        data-testid={testId ? `${testId}-${item.id}` : undefined}
        disabled={disabled}
        inlineText
        onClick={() => onChange(item)}
      >
        {item.text}
      </SubTabButton>
    ))}
  </StyledSubTabBar>
);

export const SubTabBar = observer(USubTabBar);
